import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Looks up which private-pricing tier applies to a given guest count.
// Each tier: {min_guests, max_guests (null = no upper limit), mode: "per_person"|"flat"|"contact", price}.
// Returns the matching tier object, or null if no tier covers this guest count.
export function findPrivateTier(tiers, guestCount) {
  if (!tiers || tiers.length === 0 || !guestCount) return null;
  return (
    tiers.find((t) => {
      const min = t.min_guests || 1;
      const max = t.max_guests; // null/undefined = unlimited
      return guestCount >= min && (max == null || guestCount <= max);
    }) || null
  );
}

// Given a matched tier and guest count, returns { mode, pricePerPerson, total } or null.
export function privateTierPrice(tier, guestCount) {
  if (!tier || tier.mode === "contact") return null;
  if (tier.mode === "flat") {
    return { mode: "flat", pricePerPerson: null, total: Number(tier.price) };
  }
  // per_person (default for backward compatibility)
  const pp = Number(tier.price);
  return { mode: "per_person", pricePerPerson: pp, total: pp * guestCount };
}
